export default "__VITE_ASSET__grEdym9B__"